import React from "react";

import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";

export default function LanguageSelector() {

    const {
        language,
        loading,
        changeLanguage
    } = useLanguage();

    const { user } = useAuth();

    const handleChange = async (event) => {

        const lang = event.target.value;

        if (lang === language) {
            return;
        }

        if (user?.id) {

            await changeLanguage(user.id, lang);

        } else {

            await changeLanguage(null, lang);

        }

    };

    return (

        <div className="d-flex align-items-center">

            <i
                className="bi bi-globe2 me-2 text-success"
                style={{ fontSize: 22 }}
            />

            <select
                className="form-select"
                style={{ width: 170 }}
                value={language}
                disabled={loading}
                onChange={handleChange}
            >

                <option value="FR">
                    🇫🇷 Français
                </option>

                <option value="AR">
                    🇩🇿 العربية
                </option>

                <option value="EN">
                    🇬🇧 English
                </option>

            </select>

        </div>

    );

}